module.exports = __webpack_public_path__ + "img/PLR.5e747a13.svg";